// i18nDCSDReportTemplate
export default {
  Message: {
    DeleteReportTemplateTitle: 'Xóa báo cáo đối chiếu',
    DeleteReportTemplate: 'Bạn có muốn xóa báo cáo {0} không?',
    CheckExistedAccountTitle: 'Yêu cầu chọn "Tài khoản" từ danh sách.',
    CheckRegisteredAccountMessage: 'Các tài khoản {0} chưa đăng ký với kho bạc. Vui lòng kiểm tra lại.',
    CheckBudgetSourceB04: 'Danh mục tính chất nguồn không hợp lệ, bạn cần chuẩn hóa trước khi cất hồ sơ.',
    FailInformation: 'Thông tin không hợp lệ',
    FailTitle: 'Không hợp lệ',
    CheckInfoAgain: 'Vui lòng kiểm tra lại.',
    CheckDuplicateComboB01a: 'Tồn tại {0} dòng đối chiếu: Mã nguồn {1}, Mã ngành KT {2}, Mã CTMT, DA {3}. ',
    CheckDuplicateComboB04a: 'Tồn tại {0} dòng đối chiếu: {1}, Tính chất nguồn {2}, Loại, Khoản {3}. ',
  },

  Tooltip: {
    BankAccount: 'Tài khoản ngân hàng, kho bạc',
    UnitOrProjectCode: 'Mã Đơn vị quan hệ ngân sách/ Dự án',
  },

  Label: {
    BankAccount: 'Tài khoản NH, KB',
    UnitOrProjectCode: 'Mã ĐVQHNS/ Dự án',
    TradingAddress: 'Địa chỉ giao dịch',
  },

  Title: {
    ReportTemplate06: 'Biểu số 06-ĐCSDTK/KBNN: Bảng xác nhận số dư tài khoản tiền gửi tại KBNN',
    ReportTemplate01:
      'Biểu số 01a-SDKP/ĐVDT: Bảng đối chiếu dự toán kinh phí ngân sách bằng hình thức rút dự toán tại kho bạc nhà nước',
    ReportTemplate04:
      ' Biểu số 04-SDKP/ĐVDT: Tình hình thực hiện dự toán của các nhiệm vụ được chuyển nguồn sang năm sau',
  },

  Command: {
    SaveShortKey: 'Lưu (Ctrl + S)',
    Save: 'Lưu',
  },
  LabelCombobox: {
    BudgetChapter: 'Mã chương',
    BudgetName: 'Mã ĐVQHNS/ Dự án',
    BudgetLevel: 'Mã cấp NS',
    EstimateType: 'Loại dự toán',
    StateTreasuryName: 'Mã KBNN giao dịch',
    FromYear: 'Từ năm',
    TransferNextYear: 'Chuyển sang năm',
  },
};
